import { ServerDataGrid } from '@cmg/data-grid';

import { useCreateColumnDefs } from './useCreateColumnDefs';
import { useDataSource } from './useDataSource';
import { useSideBarDef } from './useSidebarDef';

export const ParticipationSetsDataGrid: React.FC = () => {
  const columnDefs = useCreateColumnDefs();
  const dataSource = useDataSource();
  const sideBarDef = useSideBarDef();

  return (
    <ServerDataGrid
      serverSideDatasource={dataSource}
      columnDefs={columnDefs}
      sideBar={sideBarDef}
      cellSelection={true}
      suppressColumnVirtualisation={true}
    />
  );
};
